<template>
  <div id="app">
    <img  id="fabiLogo" alt="Fabi logo" src="./assets/logo.png">
    <div class="container navBar-container">
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <ul class="navbar-nav mx-auto">
      <li class="nav-item">
        <router-link class="spacing" to='/'>Home</router-link>
      </li>
      <li class="nav-item">
        <router-link class="spacing" to='/menü'>Menü</router-link>
      </li>
      <li class="nav-item">
        <router-link class="spacing" to='/kontakt'>Kontakt</router-link>
      </li>
    </ul>
</nav>
    </div>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: black;
}
img{
  margin-bottom: 25px;
}
#fabiLogo{
  margin-left: 60px;
}
.nav-item{
  margin: 5px 25px;
}
a {
    color: red;
    text-decoration: none;
    background-color: transparent;
}
@media only screen 
    and (max-width : 600px)  {
      #fabiLogo{
    width: 40%;
}
    }
@media only screen 
    and (max-width : 800px)
    and (min-width : 601px)   {
      #fabiLogo{
    width: 30%;
}
}
@media only screen 
    and (max-width : 1200px) 
        and (min-width : 801px)  {
      #fabiLogo{
    width: 25%;
}
     }
</style>
